window.addEventListener('load', function () {
    let isFling     = document.title.toLowerCase().indexOf('fling')

    //check is product is fling disposable, add new vars for other products added to qty price rule discounts.
    if (isFling > 0) {

        //get qty and price from the discounts table on page
        function tableToArray(table_id, originalPrice) {
            const priceTable    = document.getElementById(table_id).rows
            const ourPriceArray = []
            const ourPrices     = []
            for (let i = 0; i < priceTable.length; i++) {
                const el = priceTable[i].children
                const ourPriceElm = []
                for (let j = 0; j < el.length; j++) {
                    ourPriceElm.push(el[j].innerText);
                }
                ourPriceArray.push(ourPriceElm)

            }

            ourPriceArray.forEach(function (price) {
                if (parseInt(price[0])) {
                    const qty = parseInt(price[0]);
                    const discountPrice = price[1]
                    ourPrices.push({"qty": qty, "discountPrice": discountPrice})
                }
            })
            ourPrices.unshift(originalPrice)
            return ourPrices
        }

        //callback to change price shown based on qty selected...
        //add the original price red slash through text if discount before new price
        function bundleOptionCallback(event) {
            const ourParentChildren = event.target.offsetParent.childNodes
            const priceDisplays = document.querySelectorAll('.ProductPrice-product-template')
            let oldPrice = document.querySelector('.old-price') ?? false
            let ourNewQty

            ourParentChildren.forEach((child) => {
                if (child.localName === 'input' && child.name !== 'id') {
                    ourNewQty = parseInt(child.value)
                    if (event.target.classList.contains('quantity-plus')) {
                        ourNewQty = ourNewQty + 1
                    }
                    if (event.target.classList.contains('quantity-minus')) {
                        ourNewQty = ourNewQty - 1
                    }
                }
            })

            if (!oldPrice) {
                let oldPriceDiv
                oldPrice = priceDisplays[0].innerHTML

                priceDisplays.forEach((price) => {
                    oldPriceDiv = document.createElement('div')
                    oldPriceDiv.innerText = priceDisplays[0].innerHTML
                    oldPriceDiv.classList.add('old-price')
                    oldPriceDiv.style.display = 'none'
                    price.parentNode.insertBefore(oldPriceDiv, price.parentNode.firstChild)
                })
            } else {
                oldPrice = oldPrice.innerHTML
            }

            const originalPrice = { "qty": 1, "discountPrice": document.querySelector('.old-price').innerHTML + " each"}
            const ourDiscountedPrices = tableToArray('wsaio-volume-discount--table', originalPrice)

            ourDiscountedPrices.forEach(function (price) {
                if (price.qty === ourNewQty || price.qty < ourNewQty) {
                    priceDisplays.forEach(priceShown => priceShown.innerHTML = price.discountPrice.slice(0, price.discountPrice.indexOf(' ')) )
                }
            })
            priceDisplays.forEach(function (priceShown) {
                const oldPriceDiv = document.querySelectorAll('.old-price')
                const currentPrice = parseFloat(priceShown.innerHTML.substring(1))
                const originalPrice = parseFloat(oldPrice.substring(1))
                if (currentPrice === originalPrice) {
                    oldPriceDiv.forEach(price => price.style.display = 'none')
                } else {
                    oldPriceDiv.forEach(price => price.style.display = 'inline')
                }
            })
        }

        //add event listeners
        function addBundleOptionsListeners() {
            //set initial selectors
            const qtyButtons        = document.querySelectorAll('.btn-number');
            const qtyInputs         = document.querySelectorAll('.input-qty')
            const pricePerItemDiv   = document.createElement('div');
            const priceChild        = document.querySelector('.ProductPrice-product-template');

            //create price per pack text div
            pricePerItemDiv.innerText = '*price per 10-pack';
            pricePerItemDiv.classList.add('price-per-pack')
            priceChild.parentNode.insertBefore(pricePerItemDiv, priceChild.nextSibling);
            //Add listeners to all options
            qtyButtons.forEach((button) => button.addEventListener('click', bundleOptionCallback, true))
            qtyInputs.forEach((button) => button.addEventListener('input', bundleOptionCallback, true))
        }
        addBundleOptionsListeners();
    }
})